import React from "react";
import { TbUserHeart } from "react-icons/tb";
import aboutImg1 from "../../assets/images/about.jpeg";

export default function AboutSection() {
  return (
    <div className="flex flex-col md:flex-row items-center justify-between bg-gradient-to-r from-white to-blue-100 px-6 md:px-20 py-10 font-[Poppins] text-gray-800">
     
      <div className="w-full md:w-1/2 text-center md:text-left mb-6 md:mb-0 mr-7">
        <h2 className="text-2xl md:text-4xl font-extrabold italic text-[#5c1a32] leading-snug">
          About us beyond your expectations
        </h2>
        <p className="mt-6 text-base md:text-base leading-relaxed text-black">
          We go beyond expectations to bring comfort and care into your daily life.
          With reliable services in oxygen delivery, laundry care, and clean water supply,
          we combine convenience with quality to support your everyday needs.
          Count on us for fast, friendly, and dependable service—because you deserve nothing less.
        </p>

       
        {/* <div className="bg-white shadow-md flex items-center gap-4 p-4 rounded-xl mt-6 max-w-sm mx-auto md:mx-0">
          <TbUserHeart size={36} className="text-[#343a40]" />
          <div>
            <p className="text-2xl md:text-3xl font-bold text-[#5c1a32]">800+</p>
            <p className="text-sm text-gray-700">Happy Customers per month</p>
          </div>
        </div> */}
      </div>

  
      <div className="w-full md:w-1/2">
        <img
          src={aboutImg1}
          alt="About"
          className="w-full h-auto rounded-xl shadow-md"
        />
      </div>
    </div>
  );
}
